export type Bono = {
  number: number
  icon: 'rocket' | 'calendar' | 'chart' | 'repeat' | 'utensils' | 'tag'
  title: string
  body: string[]
  value: string
}

export const bonos: Bono[] = [
  {
    number: 1,
    icon: 'rocket',
    title: 'Guía de Inicio Rápido: tu primera semana sin miedo',
    body: [
      'No sabés por dónde empezar. Este bono resuelve exactamente eso.',
      'En 10 minutos sabés qué comprar, qué cocinar y qué evitar durante los primeros 7 días — sin abrumarte, sin dudar, con el camino completamente claro.',
    ],
    value: '$8.000',
  },
  {
    number: 2,
    icon: 'calendar',
    title: 'Planificador Mensual de Comidas Para Diabéticos',
    body: [
      '4 semanas de menús diarios ya organizados. Desayuno, almuerzo, merienda y cena — sin repetir, sin improvisar.',
      'Imprimís, pegás en la heladera y el mes está resuelto.',
    ],
    value: '$10.000',
  },
  {
    number: 3,
    icon: 'chart',
    title: 'Tracker “Mi Control Diario”: glucosa y alimentación',
    body: [
      'Lo que no se mide, no se mejora. Esta plantilla de seguimiento visual te permite registrar comidas y glucosa día a día, en un formato que lleva 2 minutos completar.',
      'Cuando el control se ve, mantenerlo deja de ser un esfuerzo y se convierte en un hábito.',
    ],
    value: '$9.000',
  },
  {
    number: 4,
    icon: 'repeat',
    title: 'Guía Maestra de Sustituciones Criollas',
    body: [
      'La guía de reemplazos más completa para la cocina argentina, en una sola hoja. Azúcar, harinas, grasas, salsas y condimentos: cada ingrediente problemático tiene su versión apta con el mismo sabor.',
      'Pegala en la heladera. Usala cada vez que cocinás. Nunca más improvises un reemplazo.',
    ],
    value: '$8.000',
  },
  {
    number: 5,
    icon: 'utensils',
    title: 'Guía Para Comer Afuera Sin Perder El Control',
    body: [
      'Asados en lo de un amigo. Cumpleaños. Restaurantes. Fiestas. Viajes. Las situaciones sociales son donde el sistema más se rompe — y donde más solo/a te sentís con la diabetes.',
      'Qué pedir, qué evitar, cómo decirlo sin que sea incómodo y cómo disfrutar sin culpa ni miedo. Porque la diabetes no debería sacarte de la mesa.',
    ],
    value: '$9.000',
  },
  {
    number: 6,
    icon: 'tag',
    title: 'Kit de Etiquetas y Tarjetas de Recetas Para Imprimir',
    body: [
      'Organizá tu cocina de una vez: etiquetas para frascos y alimentos, tarjetas de recetas para tener a mano, carteles de porciones para no calcular a ojo.',
      'El sistema visible en el lugar donde más lo necesitás: tu propia cocina.',
    ],
    value: '$9.000',
  },
]
